// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"aws":"bd0605c4","lsc":"bf460989","others":"de1eb690"}[chunkId] + ".chunk.js";
};